import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import '../../../styles/RegDashboard.css';

export function AdminDashAccountsTable(props) {
    const [filteredLimitedAccounts, setFilteredLimitedAccounts] = useState(null);

    useEffect(() => {
        setFilteredLimitedAccounts(props.filteredLimitedAccounts)
    },[props])

    const checkAccountComplete = (account) => {
        var result;
        if (account.acctId === 0 && account.legalName && account.legalName !== "" && account.participantType && account.participantType !== ""
            && account.participantType !== "None" && account.location.street && account.location.street !== "" && account.location.city
            && account.location.city !== "" && account.location.state && account.location.state !== "" && account.location.zipCode
            && account.location.zipCode !== "") {
            result = true;
        }
        else {
            result = false;
        }
        return result;
    }

    return (
                    <Table className="account-table"
                        id="account-table"
                        striped
                        bordered
                        hover
                        responsive="md"
                        variant="light">
                        <thead>
                            <tr>
                                <th>Organization Name</th>
                                <th>Date Created</th>
                                <th>Account Details Status</th>
                                <th>Active Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredLimitedAccounts && filteredLimitedAccounts.map((account, index) => {
                                return (
                                    <tr onClick={() => { sessionStorage.setItem("account", JSON.stringify(account.basics)); window.location.href = "/registration-dashboard" }} key={"account" + index}>
                                        <td>{account.legalName} <br /> {(account.departmentName) ? account.departmentName : ""}</td>
                                        <td>{account.createdDate.split("T")[0]}</td>
                                        <td> {(checkAccountComplete(account) ? "Complete" : "Incomplete")} </td>
                                        <td>{account.status}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
    );
}
